import classNames from "classnames";
import React from "react";
import ReactResizeDetector from "react-resize-detector";

type ResponsiveSizeClass = "sm" | "md" | "lg" | "xl" | "2xl";

export const ResponsiveProvider: React.FC<{ id: string; className?: string; prefix?: string }> = p => {
    const { prefix = "gp" } = p;
    return (
        <ReactResizeDetector handleWidth={true}>
            {({ width }) => {
                let cname = "";
                let sizeClass: ResponsiveSizeClass | undefined;
                width = width ?? 0;
                if (width > 400) {
                    cname += `${prefix}-sm `;
                    sizeClass = "sm";
                }
                if (width > 640) {
                    cname += `${prefix}-md `;
                    sizeClass = "md";
                }
                if (width > 768) {
                    cname += `${prefix}-lg `;
                    sizeClass = "lg";
                }
                if (width > 1024) {
                    cname += `${prefix}-xl `;
                    sizeClass = "xl";
                }
                if (width > 1280) {
                    cname += `${prefix}-2xl `;
                    sizeClass = "2xl";
                }
                return (
                    <div id={p.id} className={classNames(cname, p.className)}>
                        <ResponsiveSizeContext.Provider value={sizeClass}>{p.children}</ResponsiveSizeContext.Provider>
                    </div>
                );
            }}
        </ReactResizeDetector>
    );
};

const ResponsiveSizeContext = React.createContext<ResponsiveSizeClass | undefined>(undefined);

export function useResponsiveSizeClass(): ResponsiveSizeClass | undefined {
    return React.useContext(ResponsiveSizeContext);
}
